import { Tag } from "antd";
const LeadStatusTag = ({ statusVal }) => {
  let status = statusVal.toLowerCase();
  return (
    <Tag
      bordered={false}
      color={
        status === "approved"
          ? "green"
          : status === "lead generated"
          ? "gold"
          : status === "rejected"
          ? "error"
          : status === "on hold"
          ? "volcano"
          : status === "Closed"
          ? "volcano"
          : status === "Completed"
          ? "green"
          : "geekblue"
      }
    >
      {statusVal}
    </Tag>
  );
};
export default LeadStatusTag;
